var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full rounded tile",style:({
    borderRadius: _vm.borderRadius,
    boxShadow: _vm.boxShadow,
    background: _vm.background,
    border: _vm.border,
  })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }